import { render, staticRenderFns } from "./fsModalDel.vue?vue&type=template&id=6fd90d9e"
import script from "./fsModalDel.vue?vue&type=script&lang=js"
export * from "./fsModalDel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports